var _path;

import * as React from "react";

function SvgCloseBoldCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C11.161 4 4 11.161 4 20s7.161 16 16 16 16-7.161 16-16S28.839 4 20 4zm0 28.903C12.871 32.903 7.097 27.13 7.097 20 7.097 12.871 12.87 7.097 20 7.097c7.129 0 12.903 5.774 12.903 12.903 0 7.129-5.774 12.903-12.903 12.903zm6.568-16.916L22.555 20l4.013 4.013a.775.775 0 010 1.097l-1.458 1.458a.775.775 0 01-1.097 0L20 22.555l-4.013 4.013a.775.775 0 01-1.097 0l-1.458-1.458a.775.775 0 010-1.097L17.445 20l-4.013-4.013a.775.775 0 010-1.097l1.458-1.458a.775.775 0 011.097 0L20 17.445l4.013-4.013a.775.775 0 011.097 0l1.458 1.458a.775.775 0 010 1.097z"
  })));
}

export default SvgCloseBoldCircle;